import state from "../../data/stateActive.json";
import { useNavigate } from "react-router-dom";
import {
  ButtonSearchComponent,
  FilterComponent,
  InputSearchComponent,
} from "../../components";

export const NoteSearchContainer = () => {
  const navigate = useNavigate();
  const filter = () => {
    const state = document.getElementById("stateNote").value;
    const search = document.getElementById("searchNote").value;

    let url = `/productos/notas?`;
    if (state !== "null") {
      url = url.concat(`active=${state}`);
    }
    if (search !== "null") {
      url = url.concat(`&search=${search}`);
    }
    navigate(url);
  };
  const dataInput = { id: "searchNote", placeholder: "Buscar Nota" };

  const handleEnter = (e) => {
    if (e.key !== "Enter") return;
    filter();
  };
  return (
    <div className="noteSearchContainer">
      <div className="noteSearchContainer__filters">
        <div className="noteSearchContainer__filters__item">
          <FilterComponent data={state} name={"Estado"} id={"stateNote"} />
        </div>
      </div>
      <div className="noteSearchContainer__search">
        <div className="noteSearchContainer__search__input">
          <InputSearchComponent data={dataInput} onKeyDown={handleEnter} />
        </div>
        <div className="noteSearchContainer__search__button">
          <ButtonSearchComponent filter={filter} />
        </div>
      </div>
    </div>
  );
};
